import { render, staticRenderFns } from "./PaymentRegistryListTable.vue?vue&type=template&id=494c4b99&"
import script from "./PaymentRegistryListTable.vue?vue&type=script&lang=js&"
export * from "./PaymentRegistryListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports